import React from "react";
import { cn } from "@/lib/utils";

// États d'un abonnement, calculés par le serveur (solde recompté à chaque lecture).
export const SUB_STATE = {
  active: { label: "En cours", cls: "text-violet-700 bg-violet-100 dark:bg-violet-900/30 dark:text-violet-300" },
  low: { label: "Bientôt épuisé", cls: "text-amber-700 bg-amber-100 dark:bg-amber-900/30 dark:text-amber-400" },
  exhausted: { label: "Épuisé", cls: "text-red-600 bg-red-100 dark:bg-red-900/30 dark:text-red-400" },
  overdrawn: { label: "À régulariser", cls: "text-red-600 bg-red-100 dark:bg-red-900/30 dark:text-red-400" },
  cancelled: { label: "Annulé", cls: "text-muted-foreground bg-muted" },
};

export const visitesTxt = (n) => `${n} visite${Math.abs(n) > 1 ? "s" : ""}`;

// Solde total des abonnements non annulés d'un client (null s'il n'en a aucun).
export function clientSubscriptionSummary(subs, clientId) {
  const mine = (subs || []).filter((s) => s.client_id === clientId && s.status !== "cancelled");
  if (!mine.length) return null;
  return { remaining: mine.reduce((t, s) => t + (s.remaining || 0), 0), count: mine.length };
}

// « Abonné — 6 visites restantes » (orange à 2 ou moins, rouge à 0 ou moins).
export default function SubscriptionBadge({ summary, className, testid }) {
  if (!summary) return null;
  const r = summary.remaining;
  const cls = r <= 0 ? SUB_STATE.exhausted.cls : r <= 2 ? SUB_STATE.low.cls : SUB_STATE.active.cls;
  const txt = r < 0 ? `Abonné — à régulariser (${r})` : `Abonné — ${visitesTxt(r)} restante${r > 1 ? "s" : ""}`;
  return (
    <span className={cn("px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide rounded-full whitespace-nowrap", cls, className)} data-testid={testid}>{txt}</span>
  );
}
